/* eslint-disable max-statements */
import { EipError } from '@wolffun/shared/src/types';
import { combineReducers } from 'redux';
import { ActionType, AppError } from './types';
import { CurrencyType } from '@wolffun/system-currency';
const reducers = {
  createAccount: (state = {
    loading: false,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.CREATE_ACCOUNT_REQUESTED:
        {
          return { ...state,
            loading: true
          };
        }

      case ActionType.CREATE_ACCOUNT_SUCCESS:
        {
          return { ...state,
            loading: false,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.CREATE_ACCOUNT_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      case ActionType.USER_SIGN_OUT:
        {
          return {
            loading: false,
            error: AppError.NO_ERROR
          };
        }

      default:
        {
          return state;
        }
    }
  },
  updateProfile: (state = {
    invalidated: true,
    loading: false,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.UPDATE_PROFILE_REQUESTED:
        {
          return { ...state,
            loading: true,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.UPDATE_PROFILE_SUCCESS:
        {
          return { ...state,
            loading: false,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.UPDATE_PROFILE_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  connectWallet: (state = {
    loading: false,
    error: EipError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.CONNECT_WALLET_REQUESTED:
        {
          return { ...state,
            loading: true,
            error: EipError.NO_ERROR
          };
        }

      case ActionType.CONNECT_WALLET_SUCCESS:
        {
          return { ...state,
            loading: false,
            error: EipError.NO_ERROR,
            accounts: action.payload.accounts
          };
        }

      case ActionType.CONNECT_WALLET_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      case ActionType.UPDATE_WALLET_WBNB_BALANCE:
        {
          return { ...state,
            wbnbBalance: action.payload.balance
          };
        }

      case ActionType.UPDATE_WALLET_THC_BALANCE:
        {
          return { ...state,
            thcBalance: action.payload.balance
          };
        }

      case ActionType.UPDATE_WALLET_BUSD_BALANCE:
        {
          return { ...state,
            busdBalance: action.payload.balance
          };
        }

      case ActionType.UPDATE_WALLET_BUSDT_BALANCE:
        {
          return { ...state,
            busdtBalance: action.payload.balance
          };
        }

      case ActionType.UPDATE_WALLET_THG_BALANCE:
        {
          return { ...state,
            thgBalance: action.payload.balance
          };
        }

      default:
        {
          return state;
        }
    }
  },
  linkWallet: (state = {
    loading: false,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.LINK_WALLET_CLEAR_ERROR:
        {
          return { ...state,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.LINK_WALLET_REQUESTED:
        {
          return { ...state,
            loading: true
          };
        }

      case ActionType.LINK_WALLET_SUCCESS:
        {
          return { ...state,
            loading: false,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.LINK_WALLET_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  userProfile: (state = {
    loading: false,
    invalidated: true,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.UPDATE_USER_PROFILE_REQUESTED:
        {
          return { ...state,
            loading: true,
            invalidated: true
          };
        }

      case ActionType.UPDATE_USER_PROFILE_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            user: action.payload.user
          };
        }

      case ActionType.UPDATE_USER_PROFILE_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      case ActionType.USER_SIGN_OUT:
        {
          return {
            loading: false,
            invalidated: true,
            error: AppError.NO_ERROR
          };
        }

      default:
        {
          return state;
        }
    }
  },
  userSignIn: (state = {
    loading: false,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.AUTHENTICATE_USER_REQUESTED:
        {
          return { ...state,
            loading: true,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.CREATE_ACCOUNT_SUCCESS:
        {
          return { ...state,
            loading: false,
            error: AppError.NO_ERROR,
            accessToken: action.payload.accessToken,
            refreshToken: action.payload.refreshToken
          };
        }

      case ActionType.AUTHENTICATE_USER_SUCCESS:
        {
          const {
            accessToken
          } = action.payload;
          return { ...state,
            loading: false,
            error: AppError.NO_ERROR,
            accessToken
          };
        }

      case ActionType.AUTHENTICATE_USER_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      case ActionType.USER_SIGN_OUT:
        {
          return {
            loading: false,
            error: AppError.NO_ERROR
          };
        }

      default:
        {
          return state;
        }
    }
  },
  sendCodeToEmail: (state = {
    loading: false,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.SEND_CODE_TO_EMAIL_REQUESTED:
        {
          return { ...state,
            loading: true
          };
        }

      case ActionType.SEND_CODE_TO_EMAIL_SUCCESS:
        {
          return { ...state,
            loading: false,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.SEND_CODE_TO_EMAIL_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      case ActionType.USER_SIGN_OUT:
        {
          return {
            loading: false,
            error: AppError.NO_ERROR
          };
        }

      default:
        {
          return state;
        }
    }
  },
  refreshToken: (state = {
    error: AppError.NO_ERROR,
    isForceLogout: false
  }, action) => {
    switch (action.type) {
      case ActionType.REFRESH_TOKEN_FAILED:
        {
          return {
            error: action.payload.error,
            pathname: action.payload.pathname,
            isForceLogout: true
          };
        }

      case ActionType.USER_SIGN_OUT:
        {
          return { ...state,
            isForceLogout: false
          };
        }

      case ActionType.AUTHENTICATE_USER_REQUESTED:
      case ActionType.AUTHENTICATE_USER_SUCCESS:
        {
          return {
            error: AppError.NO_ERROR,
            isForceLogout: false
          };
        }

      default:
        return state;
    }
  },
  avatarConfigs: (state = {
    invalidated: true,
    loading: false,
    error: AppError.NO_ERROR,
    avatarConfigVer: -1,
    avatarConfigs: undefined
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_AVATAR_CONFIG_REQUESTED:
        return { ...state,
          loading: true
        };

      case ActionType.FETCH_AVATAR_CONFIG_FAILURE:
        return { ...state,
          loading: false,
          error: action.payload.error
        };

      case ActionType.FETCH_AVATAR_CONFIG_SUCCESS:
        return { ...state,
          invalidated: false,
          loading: false,
          error: AppError.NO_ERROR,
          avatarConfigVer: action.payload.avatarConfigVer ? action.payload.avatarConfigVer : state.avatarConfigVer,
          avatarConfigs: action.payload.data ? action.payload.data : state.avatarConfigs
        };

      default:
        return state;
    }
  },
  ingameBalance: (state = {
    invalidated: true,
    loading: false,
    error: AppError.NO_ERROR,
    data: {
      balance: {
        gPP: {
          token: CurrencyType.GPP,
          value: '0'
        },
        gTHC: {
          token: CurrencyType.GTHC,
          value: '0'
        },
        gTHG: {
          token: CurrencyType.GTHG,
          value: '0'
        },
        gPT: {
          token: CurrencyType.GPT,
          value: '0'
        },
        gMQP: {
          token: CurrencyType.GMQP,
          value: '0'
        }
      },
      config: {
        thcSpentQuestionMask: 0,
        minFeeCashoutTHC: 0,
        minFeeCashoutTHG: 0,
        perFeeCashoutTHC: 0,
        perFeeCashoutTHG: 0,
        timeCapClaimedTHC: 0,
        timeCapClaimedTHG: 0,
        timeToClaimToken: 0,
        version: -1
      },
      userCap: {
        lastTimeClaimedTHC: 0,
        lastTimeClaimedTHG: 0,
        totalTHCClaimed: 0,
        totalTHGClaimed: 0,
        expiredMintHero: 0,
        expiredMintCosmetic: 0
      }
    }
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_INGAME_BALANCE_REQUESTED:
        {
          return { ...state,
            invalidated: true,
            loading: true,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.FETCH_INGAME_BALANCE_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      case ActionType.FETCH_INGAME_BALANCE_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  cosmeticItemsConfigs: (state = {
    invalidated: true,
    loading: false,
    error: AppError.NO_ERROR,
    cosmeticConfigVer: -1,
    cosmeticConfigs: undefined,
    imgPathPattern: '',
    sellFee: 0,
    minSale: 0,
    maxSale: 0
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_COSMETIC_CONFIG_REQUESTED:
        return { ...state,
          loading: true
        };

      case ActionType.FETCH_COSMETIC_CONFIG_FAILURE:
        return { ...state,
          loading: false,
          error: action.payload.error
        };

      case ActionType.FETCH_COSMETIC_CONFIG_SUCCESS:
        return { ...state,
          invalidated: false,
          loading: false,
          error: AppError.NO_ERROR,
          cosmeticConfigVer: action.payload.cosmeticConfigVer ? action.payload.cosmeticConfigVer : state.cosmeticConfigVer,
          cosmeticConfigs: action.payload.cosmeticConfigs ? action.payload.cosmeticConfigs : state.cosmeticConfigs,
          imgPathPattern: action.payload.imgPathPattern ? action.payload.imgPathPattern : state.imgPathPattern,
          sellFee: action.payload.sellFee ? action.payload.sellFee : state.sellFee,
          minSale: action.payload.minSale ? action.payload.minSale : state.minSale,
          maxSale: action.payload.maxSale ? action.payload.maxSale : state.maxSale
        };

      default:
        return state;
    }
  },
  confirmCashout: (state = {
    loading: false,
    error: AppError.NO_ERROR,
    invalidated: true,
    data: {
      exchangeRate: 0,
      expiredTime: 0
    }
  }, action) => {
    switch (action.type) {
      case ActionType.INVALIDATE_CONFIRM_CASHOUT:
        {
          return { ...state,
            invalidated: true,
            error: AppError.NO_ERROR,
            data: {
              exchangeRate: 0,
              expiredTime: 0
            }
          };
        }

      case ActionType.CONFIRM_CASHOUT_REQUESTED:
        {
          return { ...state,
            loading: true,
            invalidated: true
          };
        }

      case ActionType.CONFIRM_CASHOUT_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: {
              exchangeRate: action.payload.exchangeRate,
              expiredTime: action.payload.expiredTime
            }
          };
        }

      case ActionType.CONFIRM_CASHOUT_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  avatarAllowedConfigs: (state = {
    invalidated: true,
    loading: false,
    error: AppError.NO_ERROR,
    avatarAllowedConfigs: undefined
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_AVATAR_ALLOWED_CONFIG_REQUESTED:
        return { ...state,
          loading: true
        };

      case ActionType.FETCH_AVATAR_ALLOWED_CONFIG_FAILURE:
        return { ...state,
          loading: false,
          error: action.payload.error
        };

      case ActionType.FETCH_AVATAR_ALLOWED_CONFIG_SUCCESS:
        return { ...state,
          invalidated: false,
          loading: false,
          error: AppError.NO_ERROR,
          avatarAllowedConfigs: action.payload.data ? action.payload.data : state.avatarAllowedConfigs
        };

      default:
        return state;
    }
  },
  updateAvatar: (state = {
    loading: false,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.UPDATE_AVATAR_REQUESTED:
        {
          return { ...state,
            loading: true
          };
        }

      case ActionType.UPDATE_AVATAR_SUCCESS:
        {
          return { ...state,
            loading: false,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.UPDATE_AVATAR_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  cashOutLimit: (state = {
    loading: false,
    error: AppError.NO_ERROR,
    invalidated: true
  }, action) => {
    switch (action.type) {
      case ActionType.INVALIDATE_CASHOUT_LIMIT:
        {
          return { ...state,
            invalidated: true,
            data: undefined
          };
        }

      case ActionType.FETCH_CASHOUT_LIMIT_REQUESTED:
        {
          return { ...state,
            loading: true
          };
        }

      case ActionType.FETCH_CASHOUT_LIMIT_SUCCESS:
        {
          return { ...state,
            loading: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      case ActionType.FETCH_CASHOUT_LIMIT_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  checkAccountCashout: (state = {
    loading: false,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_CHECK_ACCOUNT_CASHOUT_REQUESTED:
        {
          return { ...state,
            loading: true
          };
        }

      case ActionType.FETCH_CHECK_ACCOUNT_CASHOUT_SUCCESS:
        {
          return { ...state,
            loading: false,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.FETCH_CHECK_ACCOUNT_CASHOUT_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  selectedCosmetics: (state = {
    loading: false,
    error: AppError.NO_ERROR,
    invalidated: false
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_SELECTED_COSMETIC_REQUESTED:
        {
          return { ...state,
            loading: true
          };
        }

      case ActionType.FETCH_SELECTED_COSMETIC_FAILURE:
        {
          return { ...state,
            invalidated: true,
            loading: false,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_SELECTED_COSMETIC_SUCCESS:
        {
          return { ...state,
            invalidated: false,
            loading: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      default:
        {
          return state;
        }
    }
  },
  selectCosmetic: (state = {
    loading: false,
    error: AppError.NO_ERROR,
    invalidated: true
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_SELECT_COSMETIC_REQUESTED:
        {
          return { ...state,
            loading: true
          };
        }

      case ActionType.FETCH_SELECT_COSMETIC_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: true,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_SELECT_COSMETIC_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false
          };
        }

      default:
        {
          return state;
        }
    }
  },
  exchangeCurrency: (state = {
    invalidated: true,
    loading: false,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.EXCHANGE_CURRENCY_REQUESTED:
        {
          return { ...state,
            loading: true
          };
        }

      case ActionType.EXCHANGE_CURRENCY_SUCCESS:
        {
          return { ...state,
            invalidated: false,
            loading: false,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.EXCHANGE_CURRENCY_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  claimReferralReward: (state = {
    loading: false,
    invalidated: true,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.CLAIM_REFERRAL_REWARD_REQUESTED:
        {
          return { ...state,
            loading: true,
            invalidated: true
          };
        }

      case ActionType.CLAIM_REFERRAL_REWARD_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.CLAIM_REFERRAL_REWARD_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  claimToken: (state = {
    invalidated: true,
    loading: false,
    error: AppError.NO_ERROR,
    successItemId: 0
  }, action) => {
    switch (action.type) {
      case ActionType.CLAIM_TOKEN_REQUESTED:
        {
          return { ...state,
            loading: true
          };
        }

      case ActionType.CLAIM_TOKEN_SUCCESS:
        {
          return { ...state,
            invalidated: false,
            loading: false,
            error: AppError.NO_ERROR,
            successItemId: action.payload.id
          };
        }

      case ActionType.CLAIM_TOKEN_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  referralInfo: (state = {
    loading: false,
    invalidated: true,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_REFERRAL_INFO_REQUESTED:
        {
          return { ...state,
            loading: true
          };
        }

      case ActionType.FETCH_REFERRAL_INFO_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      case ActionType.FETCH_REFERRAL_INFO_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  cosmeticAllInventory: (state = {
    invalidated: true,
    loading: false,
    error: AppError.NO_ERROR,
    data: []
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_COSMETIC_ALL_INVENTORY_REQUESTED:
        {
          return { ...state,
            loading: true
          };
        }

      case ActionType.FETCH_COSMETIC_ALL_INVENTORY_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_COSMETIC_ALL_INVENTORY_SUCCESS:
        {
          return { ...state,
            invalidated: false,
            loading: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      default:
        {
          return state;
        }
    }
  },
  balanceHistory: (state = {
    loading: false,
    invalidated: true,
    error: AppError.NO_ERROR,
    data: []
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_BALANCE_HISTORY_REQUESTED:
        {
          return { ...state,
            loading: true,
            invalidated: true
          };
        }

      case ActionType.FETCH_BALANCE_HISTORY_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data,
            totalItems: action.payload.totalItems
          };
        }

      case ActionType.FETCH_BALANCE_HISTORY_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  thetanBoxList: (state = {
    invalidated: true,
    loading: false,
    error: AppError.NO_ERROR,
    data: []
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_THETAN_BOX_LIST_REQUESTED:
        {
          return {
            invalidated: true,
            loading: true,
            error: AppError.NO_ERROR,
            data: []
          };
        }

      case ActionType.FETCH_THETAN_BOX_LIST_SUCCESS:
        {
          const {
            data
          } = action.payload;
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data
          };
        }

      case ActionType.FETCH_THETAN_BOX_LIST_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  transactionsHistory: (state = {
    loading: false,
    invalidated: true,
    error: AppError.NO_ERROR,
    data: []
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_TRANSACTION_HISTORY_REQUESTED:
        {
          return { ...state,
            loading: true,
            invalidated: true
          };
        }

      case ActionType.FETCH_TRANSACTION_HISTORY_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data,
            totalItems: action.payload.totalItems
          };
        }

      case ActionType.FETCH_TRANSACTION_HISTORY_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  cosmeticHistory: (state = {
    loading: false,
    invalidated: true,
    error: AppError.NO_ERROR,
    data: []
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_COSMETIC_HISTORY_REQUESTED:
        {
          return { ...state,
            loading: true,
            invalidated: true
          };
        }

      case ActionType.FETCH_COSMETIC_HISTORY_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data,
            totalItems: action.payload.totalItems
          };
        }

      case ActionType.FETCH_COSMETIC_HISTORY_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  heroHistory: (state = {
    loading: false,
    invalidated: true,
    error: AppError.NO_ERROR,
    data: []
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_HERO_HISTORY_REQUESTED:
        {
          return { ...state,
            loading: true,
            invalidated: true
          };
        }

      case ActionType.FETCH_HERO_HISTORY_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data,
            totalItems: action.payload.totalItems
          };
        }

      case ActionType.FETCH_HERO_HISTORY_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  rentalHistory: (state = {
    loading: false,
    invalidated: true,
    error: AppError.NO_ERROR,
    data: []
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_RENTAL_HISTORY_REQUESTED:
        {
          return { ...state,
            loading: true,
            invalidated: true
          };
        }

      case ActionType.FETCH_RENTAL_HISTORY_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data,
            totalItems: action.payload.totalItems
          };
        }

      case ActionType.FETCH_RENTAL_HISTORY_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  vestingSafeHistory: (state = {
    loading: false,
    invalidated: true,
    error: AppError.NO_ERROR,
    data: []
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_VESTING_SAFE_HISTORY_REQUESTED:
        {
          return { ...state,
            loading: true,
            invalidated: true
          };
        }

      case ActionType.FETCH_VESTING_SAFE_HISTORY_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data,
            totalItems: action.payload.totalItems
          };
        }

      case ActionType.FETCH_VESTING_SAFE_HISTORY_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  battleRewards: (state = {
    loading: false,
    invalidated: false,
    error: AppError.NO_ERROR,
    data: [],
    totalItems: 0
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_BATTLE_REWARDS_REQUESTED:
        {
          return { ...state,
            loading: true
          };
        }

      case ActionType.FETCH_BATTLE_REWARDS_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: true,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_BATTLE_REWARDS_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data,
            totalItems: action.payload.totalItems
          };
        }

      default:
        return state;
    }
  },
  cosmeticInventory: (state = {
    invalidated: true,
    loading: false,
    error: AppError.NO_ERROR,
    data: [],
    totalItems: 0
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_COSMETIC_INVENTORY_REQUESTED:
        {
          return { ...state,
            loading: true
          };
        }

      case ActionType.FETCH_COSMETIC_INVENTORY_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_COSMETIC_INVENTORY_SUCCESS:
        {
          return { ...state,
            invalidated: false,
            loading: false,
            error: AppError.NO_ERROR,
            data: action.payload.data,
            totalItems: action.payload.totalItems
          };
        }

      default:
        {
          return state;
        }
    }
  },
  inventoryResults: (state = {
    invalidated: true,
    loading: false,
    error: AppError.NO_ERROR,
    data: []
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_INVENTORY_RESULT_REQUESTED:
        {
          return { ...state,
            loading: true
          };
        }

      case ActionType.FETCH_INVENTORY_RESULT_SUCCESS:
        {
          const {
            searchParams,
            totalItems
          } = action.payload;
          const data = new Array(totalItems).fill(null);

          if (state.data) {
            state.data.forEach((item, index) => {
              if (index < totalItems) {
                data[index] = item;
              }
            });
          }

          action.payload.data.forEach((item, index) => {
            const idx = (searchParams.from || 0) + index;

            if (idx < totalItems) {
              data[idx] = item;
            }
          });
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data,
            totalItems
          };
        }

      case ActionType.FETCH_INVENTORY_RESULT_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  referralFloatingInfo: (state = {
    loading: false,
    invalidated: true,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_REFERRAL_FLOATING_INFO_REQUESTED:
        {
          return { ...state,
            loading: true
          };
        }

      case ActionType.FETCH_REFERRAL_FLOATING_INFO_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      case ActionType.FETCH_REFERRAL_FLOATING_INFO_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  giftBoxList: (state = {
    invalidated: true,
    loading: false,
    error: AppError.NO_ERROR,
    data: [],
    isInstalledGame: false
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_GIFT_BOX_LIST_REQUESTED:
        {
          return { ...state,
            invalidated: true,
            loading: true
          };
        }

      case ActionType.FETCH_GIFT_BOX_LIST_SUCCESS:
        {
          const {
            data,
            isInstalledGame
          } = action.payload;
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data,
            isInstalledGame
          };
        }

      case ActionType.FETCH_GIFT_BOX_LIST_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  boxHistory: (state = {
    loading: false,
    invalidated: true,
    error: AppError.NO_ERROR,
    data: []
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_BOX_HISTORY_REQUESTED:
        {
          return { ...state,
            loading: true,
            invalidated: true
          };
        }

      case ActionType.FETCH_BOX_HISTORY_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data,
            totalItems: action.payload.totalItems
          };
        }

      case ActionType.FETCH_BOX_HISTORY_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  }
};
const appReducer = combineReducers(reducers);
export { reducers };
export default appReducer;